<app-loader [Parent]="this"></app-loader>
<div *ngIf="Model != null">
  <app-pageheader [Parent]="this">
  </app-pageheader>
  <div class="columns">
    <div class="column is-4">
      <article class="panel">
        <p class="panel-heading">
          Audit Details
        </p>
        <div class="panel-block">
          <span class="label">Date:</span>
          <span class="value">{{Model.AuditedAtLocalFriendlyString || (Model.AuditedAt | date:'medium')}}</span>
        </div>
        <div class="panel-block">
          <span class="label">Station:</span>
          <span class="value">
            <a [routerLink]="['/valet/stations', Model.ValetStationId]">{{Model.ValetStationName}}</a>
          </span>
        </div>
        <div class="panel-block" *ngIf="Model.AuditedByUserName">
          <span class="label">Audited By:</span>
          <span class="value">{{Model.AuditedByUserName}}</span>
        </div>
        <div class="panel-block">
          <span class="label">Sessions With Key:</span>
          <span class="value">{{Model.SessionsWithKeyCount}}</span>
        </div>
        <div class="panel-block">
          <span class="label">Sessions Without Key:</span>
          <span class="value">{{Model.SessionsWithoutKeyCount}}</span>
        </div>
        <div class="panel-block">
          <span class="label">Keys Without Matching Session:</span>
          <span class="value">{{Model.KeysWithoutSessionCount}}</span>
        </div>
      </article>

      <article class="panel">
        <p class="panel-heading has-text-warning-dark">
          Keys Without Matching Session ({{Model.KeysWithoutSessionCount}})
        </p>
        <div class="panel-block" *ngIf="Model.KeysWithNoMatchingSession?.length === 0">
          <span class="value">No unmatched key tags were scanned during this audit.</span>
        </div>
        <div class="panel-block" *ngFor="let k of Model.KeysWithNoMatchingSession">
          <span class="value">{{k.KeyIdentifier}}</span>
        </div>
      </article>
    </div>
    <div class="column is-4">
      <article class="panel">
        <p class="panel-heading">
          Sessions With Key ({{Model.SessionsWithKeyCount}})
        </p>
        <div class="panel-block" *ngIf="Model.SessionsWithKey?.length === 0">
          <span class="value">No sessions with their key in storage at audit time.</span>
        </div>
        <div class="panel-block" *ngFor="let s of Model.SessionsWithKey">
          <span class="value">
            <a [routerLink]="['/valet/inventory', s.SessionId]">Session #{{s.SessionId}}</a>
          </span>
        </div>
      </article>
    </div>
    <div class="column is-4">
      <article class="panel">
        <p class="panel-heading has-text-danger">
          Sessions Without Key ({{Model.SessionsWithoutKeyCount}})
        </p>
        <div class="panel-block" *ngIf="Model.SessionsWithoutKey?.length === 0">
          <span class="value">No sessions were missing their key at audit time.</span>
        </div>
        <div class="panel-block" *ngFor="let s of Model.SessionsWithoutKey">
          <span class="value">
            <a [routerLink]="['/valet/inventory', s.SessionId]">Session #{{s.SessionId}}</a>
          </span>
        </div>
      </article>
    </div>
  </div>
</div>
